import { Clock, ChefHat, Check, Truck, Package, MapPin } from "lucide-react";

const STEP_ICONS = {
  pending: Clock,
  preparing: ChefHat,
  ready: Check,
  delivering: Truck,
  arrived: MapPin,
  delivered: Package,
};

export default function TrackingTimeline({ timeline, delivererName, tt }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5" data-testid="tracking-timeline">
      <h3 className="font-bold text-gray-900 mb-4">{tt("orderStatus")}</h3>
      <div className="space-y-0">
        {timeline.map((step, idx) => {
          const StepIcon = STEP_ICONS[step.status];
          const isLast = idx === timeline.length - 1;
          return (
            <div key={step.status} className="flex gap-3" data-testid={`timeline-step-${step.status}`}>
              <div className="flex flex-col items-center">
                <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${step.completed ? (step.current ? "bg-emerald-500 shadow-md shadow-emerald-200" : "bg-emerald-500") : "bg-gray-200"}`}>
                  <StepIcon className={`w-4 h-4 ${step.completed ? "text-white" : "text-gray-400"}`} />
                </div>
                {!isLast && (
                  <div className={`w-0.5 h-8 ${step.completed ? "bg-emerald-400" : "bg-gray-200"}`}></div>
                )}
              </div>
              <div className="pb-6">
                <p className={`text-sm font-medium ${step.completed ? "text-gray-900" : "text-gray-400"}`}>
                  {step.label}
                </p>
                {step.time && (
                  <p className="text-xs text-gray-400 mt-0.5">
                    {new Date(step.time).toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}
                  </p>
                )}
                {step.current && step.status === "delivering" && delivererName && (
                  <p className="text-xs text-emerald-600 font-medium mt-0.5 flex items-center gap-1">
                    <Truck className="w-3 h-3" /> {delivererName}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
